// extracted by mini-css-extract-plugin
export default {"wk__emailRecommendation-loader":"loader_wk__emailRecommendation-loader__hqzCZ","wk__emailRecommendation-loader-text":"loader_wk__emailRecommendation-loader-text__1VYhB"};